/**
 * c-reveal.js — 共通スクロールリビール（下層 c- セクション用）
 *
 * モックアップ（kusu-site-*.html）の共通JSと同等の仕組み:
 *   .c-reveal を IntersectionObserver（threshold .12）で監視し、
 *   画面に入ったら .is-in を1回だけ付与して監視解除する。
 *
 * 仕様メモ:
 * - CSS は assets/c-global-layout.css にまとめてある（.c-reveal / .c-reveal.is-in）
 * - prefers-reduced-motion: reduce のときは監視せず即 .is-in（CSSでも打ち消し済み）
 * - JS無効時は layout/theme.liquid の <noscript> スタイルで常時表示に戻す
 * - IntersectionObserver 非対応環境も即 .is-in（＝常時表示）
 * - Shopify.designMode では shopify:section:load で再初期化する
 * - c-eval-charts / c-scale-chart など、セクション内実装のアニメも同じ .is-in を
 *   トリガにしているため、同一要素に .c-reveal を付けても衝突しない（同じクラスを付けるだけ）
 */
(function () {
  var SELECTOR = '.c-reveal';
  var IN_CLASS = 'is-in';
  var THRESHOLD = 0.12;
  var observer = null;

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function markIn(el) {
    el.classList.add(IN_CLASS);
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      // ビューポートより高い要素は intersectionRatio が threshold に届かないことがあるため、
      // その場合は「見え始めた時点」で発火させる
      var box = entry.boundingClientRect;
      var tall = box.height > (window.innerHeight || 0) * 0.9;
      if (!tall && entry.intersectionRatio < THRESHOLD) return;
      markIn(entry.target);
      if (observer) observer.unobserve(entry.target);
    });
  }

  function getObserver() {
    if (!observer) {
      observer = new IntersectionObserver(onIntersect, { threshold: [0, THRESHOLD] });
    }
    return observer;
  }

  function observe(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var els = root.querySelectorAll(SELECTOR);
    if (!els.length) return;

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, markIn);
      return;
    }

    var io = getObserver();
    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.cRevealInit) return;
      el.dataset.cRevealInit = '1';
      io.observe(el);
    });
  }

  function boot() {
    observe(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      observe(event.target);
    });
  }
})();
